import { connect } from 'react-redux';

import { getCurrencyCode, getIsMobile } from 'src/store/view/selectors';

import {
  getCashbackLabel,
  getCashbackLabelBackgroundColor,
  getCashbackLabelTextColor,
  getCashbackTooltip,
  getActivateCashbackForPartner,
  getCashbackIconWebp,
  getCashbackIconPng,
} from 'src/store/cashback/selectors';
import {
  isExpandableMapSelector,
  isExpandedMapSelector,
  hotelInfoForPopupSelector,
} from '../../../../../domain/state/map/selectors';
import HotelPopup from './HotelPopup';

const mapStateToProps = (state) => ({
  isExpandable: isExpandableMapSelector(state),
  isExpanded: isExpandedMapSelector(state),
  popupData: hotelInfoForPopupSelector(state),
  isMobile: getIsMobile(state),
  activateCashbackForPartner: getActivateCashbackForPartner(state),
  currencyCode: getCurrencyCode(state),
  labelColor: getCashbackLabelBackgroundColor(state),
  textColor: getCashbackLabelTextColor(state),
  cashbackTooltipText: getCashbackTooltip(state),
  cashbackLabel: getCashbackLabel(state),
  cashbackIconWebp: getCashbackIconWebp(state),
  cashbackIconPng: getCashbackIconPng(state),
});

export default connect(mapStateToProps)(HotelPopup);
